<template>
  <section class="relative">
    <div class="container">
      <div
        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded-lg border-black/10 border border-solid"
      >
        <div class="px-4 py-4">
          <div class="flex">
            <div class="flex-shrink text-center">
              <div class="cursor-pointer">
                <firm-logo
                  :size="75"
                  :img-url="logoUrl(firm)"
                  @click="$emit('loadProfileDetail')"
                />
              </div>
            </div>
            <div class="flex-grow pl-5">
              <h3
                class="text-xl leading-normal mb-2 text-mallard-500 cursor-pointer"
                @click="$emit('loadProfileDetail')"
              >
                {{ firm.displayName }}
              </h3>
              <h4 class="text-sm">{{ firm.headline }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { utils } from "common-frontend";
import FirmLogo from "./FirmLogo.vue";

const { logoUrl, keysToSnake } = utils;

export default {
  components: {
    FirmLogo,
  },
  props: {
    firm: Object,
    sharedNotes: String,
    showClientNotes: Boolean,
    clientNotes: String,
    collaborationRequestId: String,
    collaborationRequestProfileId: String,
  },
  data() {
    return {
      logoUrl,
    };
  },
  computed: {},
  watch: {
    clientNotes(note) {
      this.saveClientNotes(note);
    },
  },
  methods: {
    saveClientNotes(note) {
      const self = this;
      this.autosaveStatus = "Saving...";
      clearTimeout(this.autosaveTimeout);
      this.autosaveTimeout = setTimeout(() => {
        self.$api.axios
          .put(
            `/work/request/${self.collaborationRequestId}/profile/${self.collaborationRequestProfileId}/`,
            keysToSnake({
              clientNotes: note,
            }),
          )
          .then(() => {
            self.autosaveStatus = "Saved.";
            setTimeout(() => {
              if (self.autosaveStatus === "Saved.") {
                self.autosaveStatus = null;
              }
            }, 1000);
          });
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.markdown-container {
  p {
    margin-bottom: 20px;
  }
}
</style>
